import React, { useEffect, useState } from 'react';
import AddReferenceModal from './components/AddReferenceModal'; 
import axios from 'axios';

export default function Panelreferences() {
  const [showModal, setShowModal] = useState(false);
  const [references, setReferences] = useState([]);

  const loadData = async () => {
    try {
      // Zakładamy endpoint /api/references dla tabeli z referencjami
      const response = await axios.get('https://megamont.pl/api/references');
      setReferences(response.data);
    } catch (error) {
      console.error('Błąd podczas ładowania referencji:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Czy na pewno chcesz usunąć tę referencję?")) {
      try {
        await axios.delete(`https://megamont.pl/api/references/${id}`);
        loadData();
      } catch (error) {
        console.error('Błąd podczas usuwania:', error);
      }
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className='main RealizationsPanel'>
      <h2 className="fw-bold border-bottom pb-2 mb-3 gradient-text">Referencje</h2>
      <section className="mt-4">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center p-0 mb-1">
              <h3>Lista plików referencyjnych</h3>
              <button className="btn btn-custom" onClick={() => setShowModal(true)}>
                Dodaj Nową Referencję
              </button>
            </div>
          </div>
          <div className="col-12 p-0 m-0 shadow">
            <table className='Table'>
              <thead> 
                <tr>
                  <th>ID</th>
                  <th>Podgląd</th>
                  <th>Nazwa pliku (Baza)</th>
                  <th className="text-end pe-4">Akcje</th>
                </tr>
              </thead>
              <tbody>
                {references.length > 0 ? references.map((ref) => (
                  <tr key={ref.id}>
                    <td>{ref.id}</td>
                    <td>
                      <img 
                        src={`https://megamont.pl/uploads/references/${ref.name}`} 
                        alt="referencja" 
                        style={{ height: '50px', objectFit: 'contain', borderRadius: '4px' }}
                        onError={(e) => e.target.src = 'https://via.placeholder.com/50?text=Brak'}
                      />
                    </td>
                    <td className="small text-muted">{ref.name}</td>
                    <td className="text-end pe-4">
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(ref.id)}>
                        Usuń
                      </button>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4 text-muted">Brak referencji w systemie.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      
      {showModal && (
        <AddReferenceModal 
          onClose={() => setShowModal(false)} 
          refreshData={loadData} 
        />
      )}
    </div>
  );
}